/**
 * Displays a prominent banner on non-production environments
 * so users can easily distinguish dev/sandbox from production.
 */

/** Height of the sandbox banner in pixels (used by layouts to offset fixed elements) */
export const SANDBOX_BANNER_HEIGHT = 32;

/** Returns true if the current environment is non-production (sandbox/dev) */
export function isSandboxEnv(): boolean {
  const env = window.__QDF_ENV__;
  return !!(env && env !== 'prod' && env !== 'production');
}

export function SandboxBanner() {
  // Only show on non-prod environments
  if (!isSandboxEnv()) return null;

  return (
    <div style={{
      background: 'linear-gradient(90deg, #f59e0b 0%, #d97706 100%)',
      color: '#fff',
      textAlign: 'center',
      padding: '6px 16px',
      fontSize: '13px',
      fontWeight: 700,
      letterSpacing: '0.5px',
      textTransform: 'uppercase',
      position: 'sticky',
      top: 0,
      zIndex: 9999,
      height: `${SANDBOX_BANNER_HEIGHT}px`,
      lineHeight: `${SANDBOX_BANNER_HEIGHT - 12}px`,
      boxSizing: 'border-box',
      boxShadow: '0 2px 8px rgba(217, 119, 6, 0.3)',
    }}>
      ⚠️ Sandbox Environment — This is not production
    </div>
  );
}
